<template>  
  <v-form @submit.prevent class="enterform">
    <BetTypeEntry :bettype="localDatalist.checkin.bettype" @bettypeclick="betTypeReturned" />

    <v-row v-if="enterlength">
      <DateEntry :passeddate="sessionenddate" @dateentered="endDateEntered"/> 
      
      <v-col cols="12">
        <v-text-field
          v-model="lengthtext"
          label="How long did you play (hh:mm)?"
          @blur="validateLength(lengthtext)"
        ></v-text-field>

        <p class="center" v-if="lengthmessage">{{ lengthmessage }}</p>
      </v-col>

      <v-col cols="12">
        <v-checkbox
          v-model="enterlength"
          label="Change to start/end time"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row v-if="!enterlength">
      <DateEntry :passeddate="sessionstartdate" @dateentered="startDateEntered"/> 
      <TimeEntry :passedtime="sessionStartTime" @timeentered="startTimeEntered"/>
      
      <DateEntry :passeddate="sessionenddate" @dateentered="endDateEntered"/> 
      <TimeEntry :passedtime="sessionEndTime" @timeentered="endTimeEntered"/>

      <v-col cols="12">
        <v-checkbox
          v-model="enterlength"
          label="Change to length"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-combobox
          v-model="place"
          label="Where did you play?"
          :items="allplace"
        ></v-combobox>
      </v-col>

      <v-col cols="12">
        <v-combobox
          v-model="game"
          label="What game did you play?"
          :items="gameslist"
        ></v-combobox>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.buyin"
          label="What was the total entry fee?"
          type="number"
          step=".01"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.winnings"
          label="How much did you win?"
          type="number"
          step=".01"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.players"
          label="How many players entered the tournament?"
          type="number"
          step="1"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.finishedin"
          label="What place did you finish?"
          type="number"
          step="1"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.notes"
          label="Any notes you want to save?"
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn @click="enterSession">Enter</v-btn>
      </v-col>
          </v-row>
  </v-form>
</template>
<script setup>
import { useUserStore } from '@/stores/users';
import { usePlaceStore } from '@/stores/places';
import { useGameStore } from '@/stores/games';
import BetTypeEntry from '@/components/custom/BetTypeEntry.vue';
import { useConvertTime } from '@/compostables/useTimeConversion.js';
import { computed, onMounted, ref, reactive } from 'vue';
import DateEntry from '@/components/custom/DateEntry.vue';
import TimeEntry from '@/components/custom/TimeEntry.vue';
import { GAMES_DB, PLACES_DB, TOURNAMENT } from '@/constants/constants';
import  {updateDropDown}  from '@/api/lists.js';
import { parseLengthText } from '@/utils/globalFunctions';



let { convertTime } = useConvertTime();
const userStore = useUserStore();


//input variables
const props = defineProps(['datalist']);
const localDatalist = ref(JSON.parse(JSON.stringify(props.datalist))); 

// output variables
const emit = defineEmits(['update:datalist', 'entered']);

// Reactive variables
const feedback = ref('');
const lengthmessage = ref('');
const place = ref(null);
const game = ref(null);
const length = ref(0.0);
const lengthtext = ref('01:00');
const enterlength = ref(true);


let sessionstarttime = ref(new Date(),'fullTime24h');
//let sessionendtime = ref(new Date(),'fullTime24h');

// Variables for sending data to DateEntry component
const sessionenddate = reactive({
  enteredDate: new Date(),
  label: 'Session End Date'
});
const sessionstartdate = reactive({
  enteredDate: new Date(),
  label: 'Session Start Date'
});

//Variables for sending data to TimeEntry component
const sessionStartTime = reactive ({
  endteredTime: ref(new Date(),'fullTime24h'),
  label: 'What time did you start?'
})
const sessionEndTime = reactive ({
  endteredTime: ref(new Date(),'fullTime24h'),
  label: 'What time did you finish?'
})

// Computed properties
const gameslist = computed(() => {
  const gameStore = useGameStore();
  return gameStore.gameslist;
});

const allplace = computed(() => {
  const placeStore = usePlaceStore();
  if (userStore.favoriteplaces) {
    return userStore.favoriteplaces.concat(placeStore.placelist.filter((place) => !userStore.favoriteplaces.includes(place)));
  } else {
    return placeStore.placelist;
  }
});

// Lifecycle hook
onMounted(() => {

  try {
    //console.log('onMounted localDatalist:', props.datalist);
  
    place.value = localDatalist.value.checkin.place;
    //console.log('Mounted place:', place.value);
    game.value = localDatalist.value.checkin.game;
    //console.log('Mounted game:', game.value);
    localDatalist.value.user.alias = userStore.user.alias;
    localDatalist.value.user.user_id = userStore.user.user_id;
    //console.log('Mounted user alias:', localDatalist.value.user.alias);
    sessionstarttime = localDatalist.value.checkin.starttime
      ? localDatalist.value.checkin.starttime
      : sessionstarttime;
    localDatalist.value.checkin.sessionstartdate = localDatalist.value.checkin.sessionstartdate instanceof Date
      ? localDatalist.value.checkin.sessionstartdate
      : new Date();
    localDatalist.value.checkin.sessionenddate = new Date();
  } catch (error) {
    console.error('Error during onMounted:', error);
  }
});

// Methods
function betTypeReturned(payload) {
  localDatalist.value.checkin.bettype = payload.localvar;
  emit('update:datalist', localDatalist.value);
}
function endDateEntered(payload) {
  localDatalist.value.checkin.sessionenddate = payload;
  
}
function startDateEntered(payload) {
  localDatalist.value.checkin.sessionstartdate = payload;
  
}
function startTimeEntered(payload) {
  localDatalist.value.checkin.sessionstarttime = payload;
  
}
function endTimeEntered(payload) {
  localDatalist.value.checkin.sessionendtime = payload;

}

function enterSession() {
  feedback.value = null;
  // console.log ('entersession', enterlength.value, localDatalist.value.checkin.sessionenddate, localDatalist.value.checkin.starttime, localDatalist.value.checkin.endtime);
  if (enterlength.value) {
    localDatalist.value.checkin.sessionenddate.setHours(0, 0, 0, 0);
  } else {
    localDatalist.value.checkin.sessionenddate.setHours(0, 0, 0, 0);
    length.value =
      convertTime(localDatalist.value.checkin.endtime) -
      convertTime(localDatalist.value.checkin.starttime) +
      ((localDatalist.value.checkin.sessionenddate.setHours(0, 0, 0, 0) -
        localDatalist.value.checkin.sessionstartdate.setHours(0, 0, 0, 0)) /
        3600000);
  }
  Promise.all([
    updateDropDown(game.value, GAMES_DB, localDatalist.value.user.user_id),
    updateDropDown(place.value, PLACES_DB, localDatalist.value.user.user_id)
  ])
    .then(([gamechoice, placechoice]) => {
      if (!((localDatalist.value.checkin.sessionenddate === null) || (gamechoice === null) || (placechoice === null) || (localDatalist.value.checkin.net === null))) {
        const newrecord = {
          from: localDatalist.value.user.alias,
          user_id: localDatalist.value.user.user_id,
          sessiondate: new Date(localDatalist.value.checkin.sessionenddate),
          place: placechoice,
          type: TOURNAMENT,
          game: gamechoice,
          notes: localDatalist.value.checkin.notes,
          bettype: localDatalist.value.checkin.bettype,
          length: Number(length.value),
          buyin: Number(localDatalist.value.checkin.buyin),
          players: Number(localDatalist.value.checkin.players),
          finishedin: Number(localDatalist.value.checkin.finishedin),
          winnings: Number(localDatalist.value.checkin.winnings),
          net: Number(localDatalist.value.checkin.winnings - localDatalist.value.checkin.buyin),
          };
        feedback.value = "Session Entered!";
        localDatalist.value.checkin.buyin = 0;
        localDatalist.value.checkin.players = 0;
        localDatalist.value.checkin.finishedin = 1;
        localDatalist.value.checkin.winnings = 0;
        //console.log('Tournament checkout session entered:', newrecord);
        emit('entered', { newrecord });
      } else {
        feedback.value = "Enter all required information";
        // console.log('Tournament entry required failed:', localDatalist.value.checkin.sessionenddate, gamechoice, placechoice, localDatalist.value.checkin.net, length.value);
      }
    })
    .catch(err => {
      console.error('Error entering session:', err);
    });
}

function validateLength() {
  const decimal = parseLengthText(lengthtext.value);
  if (decimal !== null) {
    length.value = decimal;
    const timearray = lengthtext.value.split(':');
    lengthtext.value = timearray[0].toString().concat(':', timearray[1].substr(0, 2).toString());
    lengthmessage.value = '';
  } else {
    length.value = null;
    lengthmessage.value = 'Format should be hh:mm';
  }
}
</script>

<style>
.enterform {
  max-width: 500px;
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.input {
  border: medium none !important;
  margin: 0 0 10px;
  padding-left: 6px;
  min-width: 100%;
  padding: 0;
  width: 100%;
}
.checkbox {
  padding-top: 60px
}
.label {
  text-align: left;
  padding-left: 0px;
  color: black;
}
.center {
  text-align: center;
}
</style>





